module.exports = __webpack_public_path__ + "quilt2-level7.ef644ec2.png";